module.exports = __webpack_public_path__ + "static/media/join_cafe.05315f54.png";